// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBv_aY2X2_u37SsQPOiCJGhfvj2CohkYv8",
  authDomain: "nabeel-5a5cb.firebaseapp.com",
  databaseURL: "https://nabeel-5a5cb.firebaseio.com",
  projectId: "nabeel-5a5cb",
  storageBucket: "nabeel-5a5cb.appspot.com",
  messagingSenderId: "323775898026",
  appId: "1:323775898026:web:79e402b9d0b1575df8cbd3",
};
export default firebaseConfig;
